(function ($) {
    if ($('.swiper-text-block').length) {
        const swiper_text_block = new Swiper('.swiper.swiper-text', {
            spaceBetween: 100,
            autoHeight: true,
            keyboard: {
                enabled: true,
                onlyInViewport:true,
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            observer: true,
            observeParents: true,
            simulateTouch: false,
        });
    }

})(jQuery);